<template>
    <v-dialog v-model="show" max-width="640">
        <v-card color="grey lighten-2" >
            <v-toolbar color="warning" dark>
                <v-toolbar-title>Určení kontaktu na velitele zásahu (VZ)</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <set-role-form :event-id="eventId" @onClose="close"></set-role-form>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapGetters} from "vuex";
import SetRoleForm from "@/components/panel/sidebar/event/SetRoleForm.vue";

export default {
    name: 'set-role-modal',
    components: {
        SetRoleForm,
    },
    data() {
        return {
            show: false
        }
    },
    props: {
        eventId: [Number, null],
    },
    computed: {
        ...mapGetters('eventContacts', {
            contacts: 'getByEvent',
        }),
        ...mapGetters('events', {
            getEventById: 'byId',
            getIsHzsEvent: 'isHzsEvent',
        }),
        event() {
            return this.getEventById(this.eventId);
        },
    },
    methods: {
        open() {
            this.show = true;
        },
        close() {
            this.show = false;
        },
    }
}
</script>
